import { Fab } from '@mui/material';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { appNameToDisplayName, appNameToUrl } from './datasource-info';
import { DataSource } from './generated/graphql';
import { GraphqlResult } from './queries';
import { ShowGraphqlResult, TechnicalErrors } from './show-graphql-result';

const { Mijnoverheid, Belastingdienst, Mijnuwv } = DataSource;

export const ShowData = ({
  data,
  onSendClick,
  onBackClick,
}: {
  data: GraphqlResult;
  onSendClick: () => void;
  onBackClick: () => void;
}) => {
  const errorState = !!data.errors?.length;
  const { t } = useTranslation();
  return (
    <Stack spacing={2}>
      <div>
        <Typography variant="h1">{t('showData.title')}</Typography>
      </div>
      <div>
        {errorState && data.errors ? (
          <>
            <Typography
              sx={{
                marginBottom: '16px',
              }}
            >
              Er zijn fouten opgetreden bij het ophalen van de gegevens.
              Controleer of u uw gegevens kan inzien op de sites van{' '}
              <Link href={appNameToUrl[Mijnoverheid]}>
                {appNameToDisplayName[Mijnoverheid]}
              </Link>
              ,{' '}
              <Link href={appNameToUrl[Mijnuwv]}>
                {appNameToDisplayName[Mijnuwv]}
              </Link>{' '}
              of{' '}
              <Link href={appNameToUrl[Belastingdienst]}>
                {appNameToDisplayName[Belastingdienst]}
              </Link>
              .
            </Typography>
            <Typography>{t('showData.thisDataCouldNotBeRetrieved')}</Typography>
            <TechnicalErrors errors={data.errors} />
          </>
        ) : (
          <Typography>{t('showData.wantToAddData')}</Typography>
        )}
      </div>
      {errorState ? (
        <div>
          <Button variant="contained" color="primary" onClick={onBackClick}>
            {t('Terug naar login')}
          </Button>
        </div>
      ) : (
        <Fab
          id="submitDataButton"
          variant="extended"
          sx={{
            position: 'fixed',
            bottom: (theme) => theme.spacing(3),
            right: (theme) => theme.spacing(4),
            borderRadius: 0,
          }}
          color="primary"
          onClick={onSendClick}
        >
          <SendRoundedIcon sx={{ marginRight: 1 }} />
          {t('Verder')}
        </Fab>
      )}
      <div>
        <ShowGraphqlResult data={data} />
      </div>
    </Stack>
  );
};
